import React, { useEffect, useState } from "react";
import "./Styles/LoaderBar.css";
const DocumentUploadProgressLoader = () => {
  const [statusText, setStatusText] = useState("Uploading document...");

  useEffect(() => {
    const timer = setTimeout(() => {
      setStatusText("Training started...");
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="document-upload-wrapper">
      <p className="upload-text animate-pulse">{statusText}</p>
      <div className="custom-loader" />
      <div className="space-y-1 pt-8 text-[16px] text-gray-600">
        <p className="flex items-center justify-center gap-1">
          <span>
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6.45696 1.05138C7.45824 -0.350461 9.54171 -0.350461 10.5431 1.05138L10.7025 1.27456C10.8787 1.52128 11.1746 1.65338 11.4759 1.61991L12.1864 1.54095C13.7856 1.36328 15.1367 2.71447 14.9591 4.31357L14.8801 5.02412C14.8467 5.32544 14.9787 5.62132 15.2254 5.79755L15.4486 5.95696C16.8505 6.95824 16.8505 9.04171 15.4486 10.0431L15.2254 10.2025C14.9787 10.3787 14.8467 10.6746 14.8801 10.9759L14.9591 11.6864C15.1367 13.2856 13.7856 14.6367 12.1864 14.4591L11.4759 14.3801C11.1746 14.3467 10.8787 14.4787 10.7025 14.7254L10.5431 14.9486C9.54171 16.3505 7.45832 16.3505 6.45696 14.9486L6.29755 14.7254C6.12132 14.4787 5.82544 14.3467 5.52411 14.3801L4.81357 14.4591C3.21447 14.6367 1.86328 13.2856 2.04095 11.6864L2.11991 10.9759C2.15338 10.6746 2.02128 10.3787 1.77456 10.2025L1.55138 10.0431C0.149539 9.04171 0.149539 6.95832 1.55138 5.95696L1.77456 5.79755C2.02128 5.62132 2.15338 5.32544 2.11991 5.02411L2.04095 4.31357C1.86328 2.71447 3.21447 1.36328 4.81357 1.54095L5.52412 1.61991C5.82544 1.65338 6.12132 1.52128 6.29755 1.27456L6.45696 1.05138ZM11.6025 5.73443C11.9293 6.06126 11.9293 6.59117 11.6025 6.91798L8.40645 10.114C7.99595 10.5246 7.33028 10.5246 6.91978 10.114L5.39752 8.59179C5.0707 8.26498 5.0707 7.73505 5.39752 7.40824C5.72436 7.08143 6.25425 7.08143 6.58109 7.40824L7.66311 8.49027L10.4189 5.73443C10.7458 5.4076 11.2757 5.4076 11.6025 5.73443Z"
                fill="#6049E7"
              />
            </svg>
          </span>
          Ask specific questions, summarize sections, extract tables, or get
          translations.
        </p>
        <p className="flex items-center justify-center gap-1">
          <span>
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6.45696 1.05138C7.45824 -0.350461 9.54171 -0.350461 10.5431 1.05138L10.7025 1.27456C10.8787 1.52128 11.1746 1.65338 11.4759 1.61991L12.1864 1.54095C13.7856 1.36328 15.1367 2.71447 14.9591 4.31357L14.8801 5.02412C14.8467 5.32544 14.9787 5.62132 15.2254 5.79755L15.4486 5.95696C16.8505 6.95824 16.8505 9.04171 15.4486 10.0431L15.2254 10.2025C14.9787 10.3787 14.8467 10.6746 14.8801 10.9759L14.9591 11.6864C15.1367 13.2856 13.7856 14.6367 12.1864 14.4591L11.4759 14.3801C11.1746 14.3467 10.8787 14.4787 10.7025 14.7254L10.5431 14.9486C9.54171 16.3505 7.45832 16.3505 6.45696 14.9486L6.29755 14.7254C6.12132 14.4787 5.82544 14.3467 5.52411 14.3801L4.81357 14.4591C3.21447 14.6367 1.86328 13.2856 2.04095 11.6864L2.11991 10.9759C2.15338 10.6746 2.02128 10.3787 1.77456 10.2025L1.55138 10.0431C0.149539 9.04171 0.149539 6.95832 1.55138 5.95696L1.77456 5.79755C2.02128 5.62132 2.15338 5.32544 2.11991 5.02411L2.04095 4.31357C1.86328 2.71447 3.21447 1.36328 4.81357 1.54095L5.52412 1.61991C5.82544 1.65338 6.12132 1.52128 6.29755 1.27456L6.45696 1.05138ZM11.6025 5.73443C11.9293 6.06126 11.9293 6.59117 11.6025 6.91798L8.40645 10.114C7.99595 10.5246 7.33028 10.5246 6.91978 10.114L5.39752 8.59179C5.0707 8.26498 5.0707 7.73505 5.39752 7.40824C5.72436 7.08143 6.25425 7.08143 6.58109 7.40824L7.66311 8.49027L10.4189 5.73443C10.7458 5.4076 11.2757 5.4076 11.6025 5.73443Z"
                fill="#6049E7"
              />
            </svg>
          </span>
          Powered by Kroolo’s Agentic AI, your responses are context-aware and
          memory-efficient.
        </p>
      </div>
    </div>
  );
};

export default DocumentUploadProgressLoader;
